import {IPersonResponse, TPersonRequest} from '../person'
import {IMachineResponse} from '../machine'
import {IProductResponse} from '../products/product'

type personRequest = {
  name: string
  fantasyName: string
}

export type TFranchiseRequest = {
  id?: number
  type: number
  name: string
  email: string
  franchiseEmail: string
  document: string
  person: TPersonRequest
  // machines: Array<MachineRequest>
  // products: Array<TProductRequest>
  // contacts?: Array<ContactRequest>
  // addresses?: Array<AddressRequest>
  // bankData?: Array<TCreateBankPeople>
  // owners: Array<TPersonRequest>
}

export type TFranchiseSyncRequest = {
  startTime: string
  endTime: string
  gatewayCashier?: string
  gatewayHash?: string
  cieloMerchantId?: string
  cieloMerchantKey?: string
  acceptsRecurringProducts: boolean
}

export type TFranchiseResponse = {
  id: number
  type: number
  name: string
  startTime: string
  endTime: string
  createdAt: string
  updatedAt: string
  person: IPersonResponse
  machines: IMachineResponse
  products: IProductResponse
  owners: IPersonResponse
  users: {
    id: number
    name: string
    email: string
    phone: string
    createdAt: string
    updatedAt: string
  }[]
  config: IFranchiseConfigResponse
  partnerships: Partenership[]
}
export type Partenership = {
  id: number
  partnershipTypeId: number
  destinationFranchiseId: number
  destinationFranchiseName: string
  partnershipTypeName: string
}

export type TFranchisePartenershipRequest = {
  partnerships: {
    type: number
    franchise: number
  }[]
}

export type TDiscountApprovalMode = 'token' | 'review'

export type IFranchiseConfigResponse = {
  startTime: string
  endTime: string
  foreignerRegistrationsLimit: number
  gatewayCashier: string
  gatewayHash: string
  cieloMerchantId: string
  cieloMerchantKey: string
  acceptsRecurringProducts: boolean
  discountApprovalMode: TDiscountApprovalMode
  discountApprovalModes?: TDiscountApprovalMode[]
  syncUsers: boolean
  syncClients: boolean
  syncSales: boolean
  syncEvents: boolean
  createdAt: string
  updatedAt: string
}

export type TStarResponse = {
  id?: number
  description: string
  starsCount: number
  minAmount: string
  maxAmount: string
  observation: string
  active?: boolean
}[]

type AvailablePeriods = {
  monthly: string
  bimonthly: string
  quarterly: string
  semiannual: string
}
export type TInvoiceConfigResponse = {
  franchiseId?: number
  availablePeriods: AvailablePeriods
  billingPeriod: string
  invoiceDueDay: number
}

export type TInvoiceConfigRequest = {
  invoice_due_day: number
  billing_period: string
}

export type TApiPricingResponse = {
  id: number
  franchiseId: number
  endpoint: string
  notes: string
  pricePerRequest: string
  validFrom: string
}[]

export type TApiPricingRequest = {
  pricings: {
    endpoint: string
    valid_from: string
    price_per_request: number
    notes: string
  }[]
}

export type TStarProgressResponse = {
  current_star: {
    id: number
    franchise_id: number
    description: string
    stars_count: number
    min_amount: string
    max_amount: string
    observation: string
    created_at?: string
    updated_at?: string
  }
  total_sold: number
  percentage: number
  remaining: number
}

export type TStarRequest = {
  description: string
  minAmount: number
  maxAmount: number
  observation: string
}[]

export const franchiseInitValues: any = {
  type: 2,
  name: '',
  document: '',
  franchiseEmail: '',
  socialReason: '',
  fantasyName: '',
  email: '',
  addresses: [
    {
      zipCode: '',
      street: '',
      neighborhood: '',
      number: '',
    },
  ],
  contacts: [
    {
      type: 0,
      phone: '',
      countryId: 76,
      phoneCode: 55,
    },
  ],
}

export const starProgressInitValues: TStarProgressResponse = {
  current_star: {
    id: 0,
    franchise_id: 0,
    description: '',
    stars_count: 0,
    min_amount: '',
    max_amount: '',
    observation: '',
  },
  total_sold: 0,
  percentage: 0,
  remaining: 0,
}
